import { CommonModule } from '@angular/common';
import { TgCardModule, TgGridModule, TgIconLinkExternalModule } from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { PropertySideCardComponent } from './property-side-card.component';

@NgModule({
    imports: [CommonModule, TgGridModule, TgCardModule, TgIconLinkExternalModule],
    declarations: [PropertySideCardComponent],
    exports: [PropertySideCardComponent]
})
export class PropertySideCardModule {}
